// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UYL1","col":"styles_col__2O0wX"};